import React, { useState } from 'react';
import Data from '../../Data/Data.json'
import { Button, Typography, Spin } from 'antd';
import Table from '../TableResizable';
import { useNavigate } from 'react-router-dom';
import { Backspace, Print } from '@mui/icons-material';
import { Box, ButtonGroup, Button as ButtonI } from '@mui/material';
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { useAuthUser } from '../../Services/Auth/sessionAuth';
import Utilisateur from '../../Models/Utilisateur';
import Logo from "../../Res/greenLogo.png";
import ExcelIcon from '../../Res/ExcelIcon.svg';
import PageNotFound from '../../Pages/PageNotFound';
import ReformatNumber from '../../Functions/Traitement/ReformatNumber';

const PrintListOpeCm = () => {
    const [tab, setTab] = React.useState(localStorage.getItem(Data.LocalVariable.tabListcaiss) ? JSON.parse(localStorage.getItem(Data.LocalVariable.tabListcaiss) + "") : null as any)
    const navigate = useNavigate();
    const [DataExcel, SetDataExcel] = useState<any[]>([]);

    // USER SESSION
    const auth = useAuthUser();
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
    //loading Boutton  
    const [loading, setLoading] = useState(false);
    const _exporter = React.createRef<ExcelExport>();
    const exportExcel = () => {
        SetDataExcel([]);
        setLoading(true);

        tab?.data.map((data: any, indice: any) => {
            DataExcel.push({
                key: indice,
                DATOPE: data.DATOPE ? data.DATOPE : '',
                TIME: data.TIME,
                NUMSEQ: data.NUMSEQ,
                MONTAN: data.MONTAN ? ReformatNumber(data.MONTAN) : '',
                NUMCPT: data.NUMCPT,
                NUMRAP: data.NUMRAP,
                LIBOPE: data.LIBOPE,
                REMETT: data.REMETT,
                cniremet: data.cniremet,
                TYPE: data.TYPE,
                UTISAI: data.UTISAI,
                UTIVAL: data.UTIVAL
            })
        })

        if (!_exporter.current) {
            return;
        }
        _exporter.current.save();
    };

    const handleExport = () => {
        setLoading(false);
    }

    setTimeout(() => {
        if (tab == null) {

        }
    }, 2000)

    return (
        <div><br />
            {tab ?
                <>
                    <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                        <Box className='backBtnt' zIndex={2} onClick={() => {
                            switch (tab?.P) {
                                case "1": { navigate("/transaction/Counted"); break }
                                case "2": { navigate("/transaction/UnaccountedOperations"); break }
                            }
                        }}
                        ><Backspace /></Box>

                        <ExcelExport data={DataExcel} fileName= {tab?.FileName+"_"+user.codage+"_"+user.coduti+"_"+Data.LocalVariable.appName+"_"+Date.now()+".xlsx"}  ref={_exporter} onExportComplete={handleExport}>
                            <ExcelExportColumn field="DATOPE" title="Date Opération" locked={true} width={150} />
                            <ExcelExportColumn field="TIME" title="Heure" locked={true} width={70} />
                            <ExcelExportColumn field="DEDEVR" title="Date De Valeur" width={100} />
                            <ExcelExportColumn field="NUMCPT" title="NUMCPT" />
                            <ExcelExportColumn field="REPECE" title="Reference" />
                            <ExcelExportColumn field="NUMRAP" title="Ref Manuelle" />
                            <ExcelExportColumn field="LIBELL" title="Libelle" width={250} />
                            <ExcelExportColumn field="MONTAN" title="MONTANT" />
                            <ExcelExportColumn field="NBENEF" title="Beneficiare" />
                        </ExcelExport>

                        <Box marginLeft={'1%'} className={"preview_print"}>
                            <Box className={"title"} display={"flex"} fontStyle={"inherit"}>
                                <img className='printLogo' src={Logo} width={80} />
                                <Typography style={{ textAlign: 'center', marginLeft: '25%' }} className='textTitle'><b>{tab?.Title}</b></Typography >
                                <hr className='hide' />
                                <Box display={'flex'} gap={'1em'} marginLeft={'30%'}>
                                    <Button title='Imprimer ( ctrl + p )' style={{ padding: 0, margin: 0 }} onClick={() => { window.print() }} icon={<Print />} size='large' className='bt_add' type="ghost" htmlType="button" block  ></Button>
                                    <ButtonGroup disableElevation color='success' variant="outlined" aria-label="Disabled elevation buttons">
                                        <ButtonI id='ExelExport' onClick={exportExcel} disabled={tab.data.length >= 1 ? false : true}> <img style={{ width: '50%', padding: 0, margin: 0 }} src={ExcelIcon} className='ExelExport'></img> </ButtonI>
                                    </ButtonGroup>
                                </Box>
                            </Box><br />
                            <Box display={"flex"} fontStyle="inherit">
                                <Box width={"50%"} >
                                    <Box width={"120%"} display={"flex"}><Typography>AGENCE : </Typography><Typography style={{ marginLeft: '4%' }} ><b>{tab?.form?.Agence} </b> {tab?.form?.lib_Agence}</Typography></Box>
                                    <hr />
                                </Box>
                                <Box width={"30%"} marginTop={'-1%'}>
                                    <Typography style={{ textAlign: 'center' }} > <b>{"Période Allant Du " + (new Date(tab?.form?.DateDebut)).toLocaleDateString("fr") + " Au " + " " + (new Date(tab?.form?.DateFin)).toLocaleDateString("fr")}</b> </Typography>
                                </Box>
                                <Box style={{ marginLeft: '5%' }} width={"50%"}>
                                    <Box width={"120%"} display={"flex"}><Typography>{tab?.TypeList}</Typography> </Box>
                                </Box>
                            </Box>
                            <Table size='small' showHeader bordered={true} pagination={false} columns={tab?.columns} dataSource={tab.data} />

                            <Box sx={{ marginLeft: '35%' }}>

                            </Box>
                        </Box>
                    </Spin>
                </>
                :
                <PageNotFound message={"Nothing to print"} backLink={"/"} texttButton={"Back to situation client"} />}
        </div >
    );
};

export default PrintListOpeCm;